<template>
  <div v-if="inbox.requestType === inboxTypesGetValueByKey('CUSTOMER_TO_CONFIRM')" class="between__buttons">

    <template v-if="inbox.status === inboxStatusesGetValueByKey('SENT')">
      <button class="button green__lighter"
              :class="{'opacity-50 cursor-not-allowed': inbox.status !== inboxStatusesGetValueByKey('SENT')}"
              @click="acceptCustomerRequest(inbox)">
        {{ $lang.app.CONFIRM }}
      </button>
    </template>
    <template v-else>
      <span>{{ $lang.app.REQUEST_PROCESSED }}</span>
    </template>

    <template v-if="inbox.status === inboxStatusesGetValueByKey('SENT')">
      <button class="button red__lighter"
              :class="{'opacity-50 cursor-not-allowed': inbox.status !== inboxStatusesGetValueByKey('SENT')}"
              @click="refuseCustomerRequest(inbox)">
        {{ $lang.app.REFUSE }}
      </button>
    </template>

  </div>
  <div v-if="inbox.requestType === inboxTypesGetValueByKey('DEVELOPER_TO_CONFIRM')" class="between__buttons">
    <template v-if="inbox.status === inboxStatusesGetValueByKey('SENT')">
      <button class="button green__lighter"
              :class="{'opacity-50 cursor-not-allowed': inbox.status !== inboxStatusesGetValueByKey('SENT')}"
              @click="acceptDeveloperRequest(inbox)">
        {{ $lang.app.CONFIRM }}
      </button>
    </template>
    <template v-else>
      <span>{{ $lang.app.REQUEST_PROCESSED }}</span>
    </template>

    <template v-if="inbox.status === inboxStatusesGetValueByKey('SENT')">
      <button class="button red__lighter"
              :class="{'opacity-50 cursor-not-allowed': inbox.status !== inboxStatusesGetValueByKey('SENT')}"
              @click="refuseDeveloperRequest(inbox)">
        {{ $lang.app.REFUSE }}
      </button>
    </template>

  </div>
</template>
<script>
import {getValueByKey as inboxTypesGetValueByKey} from "../../../helpers/constants/inboxTypes";
import applicationApi from "../../../api/applicant/application";
import {getValueByKey as inboxStatusesGetValueByKey} from "../../../helpers/constants/inboxStatuses";

export default {
  props: {
    inbox: Object,
  },
  methods: {
    inboxTypesGetValueByKey,
    inboxStatusesGetValueByKey,
    acceptCustomerRequest(inbox) {
      applicationApi.acceptCustomerRequest(inbox.docExpertise.id, inbox.payload.customer)
          .then(() => {
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
            this.$router.push({
              name: 'ApplicantApplicationCustomerDetail',
              params: {
                applicationId: inbox.docExpertise.id
              }
            })
          }).catch(error => {
            if (error.response.status === 422) {
              this.$snotify.warning(error.response.data.message)
            } else {
              this.$snotify.error(error)
            }
          })
    },
    refuseCustomerRequest(inbox) {
      applicationApi.refuseCustomerRequest(inbox.docExpertise.id, inbox.payload.customer)
          .then(() => {
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
            this.$router.push({
              name: 'ApplicantApplicationsInboxesList',
            })
          }).catch(error => {
        if (error.response.status === 422) {
          this.$snotify.warning(error.response.data.message)
        } else {
          this.$snotify.error(error)
        }
      })
    },
    acceptDeveloperRequest(inbox) {
      applicationApi.acceptDeveloperRequest(inbox.docExpertise.id, inbox.payload.developer)
          .then(() => {
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
            this.$router.push({
              name: 'ApplicantApplicationPlannersList',
              params: {
                applicationId: inbox.docExpertise.id
              }
            })
          }).catch(error => {
        if (error.response.status === 422) {
          this.$snotify.warning(error.response.data.message)
        } else {
          this.$snotify.error(error)
        }
      })
    },
    refuseDeveloperRequest(inbox) {
      applicationApi.refuseDeveloperRequest(inbox.docExpertise.id, inbox.payload.developer)
          .then(() => {
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
            this.$router.push({
              name: 'ApplicantApplicationsInboxesList',
            })
          }).catch(error => {
        if (error.response.status === 422) {
          this.$snotify.warning(error.response.data.message)
        } else {
          this.$snotify.error(error)
        }
      })
    }
  }
}
</script>
